import { render } from "./modal-progress.vue?vue&type=template&id=31b23fe2&scoped=true"
import script from "./modal-progress.vue?vue&type=script&lang=js"
export * from "./modal-progress.vue?vue&type=script&lang=js"

import "./modal-progress.vue?vue&type=style&index=0&id=31b23fe2&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b23fe2"]])

export default __exports__